<div *ngIf="calculationResponse[0]">
    <snl-accordion [showArrow]="showArrow" [showBorder]="showBorder" [isTitleClickable]="isTitleClickable"
        [expanded]="expanded" [id]="accordionId" [settings]="accordionSettings">
        <div header-content>Distribution data</div>
        <div *ngFor="let data of calculationData">
            <ng-container *ngIf="hiddenColumnLength > 0 && data.showHiddenMsg">
                <div class="hidden-column">
                    <div class="body-b text">Hidden columns on the distribution page</div>
                    <div class="line"></div>
                </div>
            </ng-container>
            <ul class="info-list-header">
                <li>
                    <span class="body-b label-color">{{data.headingTitle}}</span>
                    <span class="section-title value">
                        <ng-container *ngIf="data.type === 'relShare' || data.type === 'profitShare' else otherType">
                            <span *ngIf="data.type === 'relShare'">{{data.headingValue | negativeToBracket}}%</span>
                            <span *ngIf="data.type === 'profitShare'">
                                <span *ngIf="isElegibleForProfitSharing">
                                    <ng-container *ngIf="toggleVal !== 'Monthly' || selectedMonth == 5 || selectedMonth == 11; else showNA">
                                        {{data.headingValue | negativeToBracket: true}}
                                    </ng-container>   
                                    <ng-template #showNA>
                                        N/A
                                    </ng-template>
                                </span>
                                <span *ngIf="!isElegibleForProfitSharing"> N/A </span>
                            </span>
                        </ng-container>
                        <!-- <ng-template #notRelShare>
                            <ng-container *ngIf="data.type === 'profitShare' && !isElegibleForProfitSharing else otherType">
                                N/A
                            </ng-container>
                        </ng-template> -->   
                        <ng-template #otherType>                            
                            {{data.headingValue | negativeToBracket: true}}
                        </ng-template>                     
                    </span>
                </li>
            </ul>
        </div>
    </snl-accordion>
    
    <div *ngFor="let data of calculationData">
        <ng-container *ngIf="!data.showHiddenMsg">
            <div class="hr-div">
                <div class="line"></div>
            </div>
        </ng-container>        
        <ng-container *ngIf="data.showHiddenMsg">
            <div class="hidden-column padding-bottom">
                <div class="body-b text">Hidden columns on the distribution page</div>
                <div class="line"></div>
            </div>
        </ng-container>
        <ng-container *ngIf="data.type === 'poolIn'">
            <ul class="info-list">
                <li>
                    <ng-container *ngIf="data.formulaText === 'poolInPerOpDaysAmt'">
                        <div><span class="section-title grey-color">Pool in </span><span class="body-b2 label-color">($/per Op. day)</span></div>
                    </ng-container>
                    <ng-container *ngIf="data.formulaText === 'poolOut'">
                        <div class="section-title grey-color">{{data.headingTitle}}</div>
                    </ng-container>
                    <ng-container *ngIf="data.formulaText === 'netPoolOutPerOpDaysAmt'">
                        <div><span class="section-title grey-color">Net pool out </span><span class="body-b2 label-color">(per Op. day)</span></div>                        
                    </ng-container>                    
                    <div class="section-title value"> {{data.headingValue | negativeToBracket: true}}</div>
                </li>
                <li class="body-b label-color">
                    <div>
                        <app-static-data [forTooltip]="false" [poolInPerOpDays]="true"
                            *ngIf="data.formulaText === 'poolInPerOpDaysAmt'"></app-static-data>
                        <app-static-data [forTooltip]="false" [poolOut]="true" *ngIf="data.formulaText === 'poolOut'"></app-static-data>
                        <app-static-data [forTooltip]="false" [netPoolOutPerOpDays]="true"
                            *ngIf="data.formulaText === 'netPoolOutPerOpDaysAmt'"></app-static-data>
                    </div>
                    <div class="body-b right-align">
                        <p> {{data.formulaValues.val1 | negativeToBracket: true}} </p>
                        <hr>
                        <p> {{data.formulaValues.val2 | negativeToBracket}} </p>
                    </div>
                </li>
            </ul>            
        </ng-container>
        <ng-container *ngIf="data.type === 'relShare'">
            <ul class="info-list">
                <li>
                    <div class="section-title grey-color">{{data.headingTitle}}</div>
                    <span class="section-title value"> {{data.headingValue | negativeToBracket}}%</span>
                </li>
                <li class="body-b label-color relativeShare">
                    <div>
                        <app-static-data [forTooltip]="false" [relativeShareInPool]="true" *ngIf="data.formulaText === 'relShare'"></app-static-data>
                    </div>
                    <div class="body-b">
                        <p>
                            {{data.formulaValues.val1 | negativeToBracket}} × {{data.formulaValues.val2 | negativeToBracket}}
                        </p>
                        <hr>
                        <p class="right-align">
                            {{data.formulaValues.val3 | negativeToBracket}}
                        </p>
                    </div>
                </li>
            </ul>            
        </ng-container>
        <ng-container *ngIf="data.type === 'grossDistribution'">
            <ul class="info-list">
                <li>
                    <div class="section-title grey-color">{{data.headingTitle}}</div>
                    <span class="section-title value"> {{data.headingValue | negativeToBracket: true}}</span>
                </li>
                <li class="body-b label-color square-bracket-gap">
                    <div>
                        <app-static-data [forTooltip]="false" [grossDistribution]="true" [poolName]="data.formulaValues.val6" *ngIf="data.formulaText === 'grossDistribution'"></app-static-data>
                    </div>
                    <div>
                        <div class="square-bracket">
                            <p class="right-align">
                                {{data.formulaValues.val1 | negativeToBracket: true}}<br>
                                + {{data.formulaValues.val2 | negativeToBracket: true}} <br>
                                - {{data.formulaValues.val3 | negativeToBracket: true}} <br>
                                - {{data.formulaValues.val4 | negativeToBracket: true}} <br>
                            </p>
                        </div>
                        <br>
                        <p class="right-align">× {{data.formulaValues.val5 | negativeToBracket}}%</p>
                    </div>
                </li>
            </ul>            
        </ng-container>
        <ng-container *ngIf="data.type === 'overheadFee'">
            <ul class="info-list">
                <li>
                    <div class="section-title grey-color">{{data.headingTitle}}</div>
                    <span class="section-title value"> {{data.headingValue | negativeToBracket: true}}</span>
                </li>
                <li class="body-b label-color">
                    <div>
                        <app-static-data [forTooltip]="false" [overheadfee]="true" [poolName]="data.formulaValues.val1" *ngIf="data.formulaText === 'overheadFee'"></app-static-data>
                    </div>
                    <div class="body-b right-align">
                        <p> {{data.formulaValues.val2 | negativeToBracket: true}} </p>
                        <p>× {{data.formulaValues.val3 | negativeToBracket}}</p>
                    </div>
                </li>
            </ul>            
        </ng-container>
        <ng-container *ngIf="data.type === 'commissionFee'">
            <ul class="info-list">
                <li>
                    <div class="section-title grey-color">{{data.headingTitle}}</div>
                    <span class="section-title value"> {{data.headingValue | negativeToBracket: true}}</span>
                </li>
                <li class="body-b label-color">
                    <div>
                        <app-static-data [forTooltip]="false" [poolName]="data.formulaValues.val4" [commissionFee]="true" *ngIf="data.formulaText === 'commissionFee'"></app-static-data>
                    </div>
                    <div class="body-b right-align">
                        <span>{{data.formulaValues.val1 | negativeToBracket}}%</span><br>
                        <span>× {{data.formulaValues.val2 | negativeToBracket: true}}</span><br>
                        <span>× {{data.formulaValues.val3 | negativeToBracket}}%</span>
                    </div>
                </li>
            </ul>            
        </ng-container>
        <ng-container *ngIf="data.type === 'bunkerFee'">
            <ul class="info-list">
                <li>
                    <div class="section-title grey-color">{{data.headingTitle}}</div>
                    <span class="section-title value"> {{data.headingValue | negativeToBracket: true}}</span>
                </li>
                <li class="body-b label-color">
                    <div>
                        <app-static-data [forTooltip]="false" [bunkerProcurementFee]="true" [forFormula]="true" *ngIf="data.formulaText === 'bunkerFee'"></app-static-data>
                    </div>
                    <div class="body-b right-align">
                        <br/>
                        <span>
                            {{data.formulaValues.val1 | negativeToBracket}} MT × {{data.formulaValues.val2 | negativeToBracket: true}}<br>
                            + {{data.formulaValues.val3 | negativeToBracket}} MT × {{data.formulaValues.val4 | negativeToBracket: true}}<br>
                            + {{data.formulaValues.val5 | negativeToBracket}} MT × {{data.formulaValues.val6 | negativeToBracket: true}}<br>
                            + {{data.formulaValues.val7 | negativeToBracket}} MT × {{data.formulaValues.val8 | negativeToBracket: true}}<br>
                        </span>
                    </div>
                </li>
            </ul>            
        </ng-container>
        <ng-container *ngIf="data.type === 'managementFee'">
            <ul class="info-list">
                <li>
                    <div class="section-title grey-color">{{data.headingTitle}}</div>
                    <span class="section-title value"> {{data.headingValue | negativeToBracket: true}}</span>
                </li>
                <li class="body-b label-color">
                    <div>
                        <app-static-data [forTooltip]="false" [managementfee]="true" *ngIf="data.formulaText === 'managementFee'"></app-static-data>
                    </div>
                    <div class="body-b right-align">
                        <span>{{data.formulaValues.val1 | negativeToBracket: true}}</span><br>
                        <span>+ {{data.formulaValues.val2 | negativeToBracket: true}}</span><br>
                        <span>+ {{data.formulaValues.val3 | negativeToBracket: true}}</span>
                    </div>
                </li>
            </ul>            
        </ng-container>
        <ng-container *ngIf="data.type === 'netPoolOut'">
            <ul class="info-list">
                <li>
                    <div class="section-title grey-color">{{data.headingTitle}}</div>
                    <span class="section-title value"> {{data.headingValue | negativeToBracket: true}}</span>
                </li>
                <li class="body-b label-color">
                    <div>
                        <app-static-data [forTooltip]="false" [netPoolOut]="true" *ngIf="data.formulaText === 'netPoolOut'"></app-static-data>
                    </div>
                    <div class="body-b right-align">
                        <span>{{data.formulaValues.val1 | negativeToBracket: true}}</span><br>
                        <span>- {{data.formulaValues.val2 | negativeToBracket: true}}</span>
                    </div>
                </li>
            </ul>            
        </ng-container>
        <ng-container *ngIf="data.type === 'profitShare'">
            <ul class="info-list">
                <li>
                    <div class="section-title grey-color">{{data.headingTitle}}</div>
                    <span class="section-title value" *ngIf="isElegibleForProfitSharing">
                        <ng-container *ngIf="toggleVal !== 'Monthly' || selectedMonth == 5 || selectedMonth == 11; else showNA">
                          {{data.headingValue | negativeToBracket: true}}
                        </ng-container>   
                        <ng-template #showNA>
                          N/A
                        </ng-template>
                    </span>
                    <span class="section-title value" *ngIf="!isElegibleForProfitSharing"> N/A </span>
                </li>
                <li class="body-b label-color square-bracket-gap" *ngIf="isElegibleForProfitSharing && (toggleVal !== 'Monthly' || selectedMonth == 5 || selectedMonth == 11)">
                    <div>
                        <app-static-data [forTooltip]="false" [profitSharing]="true" [note]="false" *ngIf="data.formulaText === 'profitShare'"></app-static-data>
                    </div>
                    <div>
                        <div class="square-bracket">
                        <p class="right-align">
                            {{data.formulaValues.val1 | negativeToBracket: true}}<br>
                            - {{data.formulaValues.val2 | negativeToBracket: true}}
                        </p>
                        </div>
                        <br>
                        <p class="right-align">× {{data.formulaValues.val3 | negativeToBracket}}%</p>
                        <p class="right-align">× {{data.formulaValues.val4 | negativeToBracket}}</p>
                    </div>
                </li>
            </ul>            
        </ng-container>
        <ng-container *ngIf="data.type === 'finalPayout' && toggleVal === 'Monthly'">
            <ul class="info-list">
                <li>
                    <div class="section-title grey-color">{{data.headingTitle}}</div>
                    <span class="section-title value"> {{data.headingValue | negativeToBracket: true}}</span>
                </li>
                <li class="body-b label-color">
                    <div>
                        <app-static-data [forTooltip]="false" [finalPayout]="true" [note]="false" *ngIf="data.formulaText === 'finalPayout'"></app-static-data>
                    </div>
                    <div class="body-b right-align">
                            {{data.formulaValues.val1 | negativeToBracket: true}}<br>
                            - {{data.formulaValues.val2 | negativeToBracket: true}}<br>
                            + {{data.formulaValues.val3 === 'N/A' ? data.formulaValues.val3 : data.formulaValues.val3 | negativeToBracket: true}}<br>
                    </div>
                </li>
            </ul>            
        </ng-container>
    </div>
</div>

